<template>

  <modal :titulo="titulo" :loading="loading" :focus="false">

    <card>

      <card-content class="row gutters-xs">

        <v-input class="col-auto" type="radio" v-model="form.categoria"
                 :options="options.categorias" />
        <v-input class="col-4" type="select" label="Tipo de imóvel"
                 v-model="form.tipoImovel"
                 :options="options.tiposImovel" />
        <v-input class="col" label="Serventia" v-model="form.serventia" :options="options.serventias" type="v-select" :error="validation.serventia"/>
        <div class="w-100"></div>
        <v-input :error="validation.tipo" class="col-4" v-model="form.tipo" :options="options.tipos"
                 type="select" label="Tipo" />
        <v-input :error="validation.codigo" class="col-4" v-model="form.codigo" type="currency" :input-props="{precision : 0}" label="Código"/>
        <v-input class="col-4" v-model="form.livroLetra" type="text" label="Letra" />
        <template v-if="form.tipo === 'TRANSCRICAO'">
          <div class="w-100"></div>
          <v-input class="col" :error="validation.livroNumero" v-model="form.livroNumero" type="text" label="Livro (Número)" />
          <v-input class="col" :error="validation.livroFolha" v-model="form.livroFolha" type="text" label="Folha" />
        </template>
        <v-input :class="'col-4'" type="text" label="CNM" class="col" v-model="form.cnm" />
        <v-input :class="'col-4'" type="text" label="CNS" class="col" v-model="form.cns" />
        <v-input :class="'col-4'" :type="'date'" label="Data Encerramento"  v-model="form.encerramento"  />
        <div class="w-100"></div>
        <v-input class="col-4" v-model="form.imovelUniao" label="Imóvel da União" type="radio" />
      </card-content>
    </card>

    <card titulo="Informações Complementares">
      <card-content class="row gutters-xs">
        <template v-if="form.categoria === 'URBANO'">
          <v-input class="col-4" type="text" label="Cadastro Imobiliário" v-model="form.cadastroImobiliario" />
        </template>

        <template v-if="form.categoria === 'RURAL'">
          <v-input class="col" type="text" label="Denominação da Área Rural" v-model="form.denominacao" />
          <div class="w-100"></div>
          <v-input class="col" type="text" label="INCRA (CCIR)" v-model="form.incra" />
          <v-input class="col" type="text" label="Código SNCR" v-model="form.codigoSncr" />
          <div class="w-100"></div>
          <v-input class="col" type="text" label="Localização" v-model="form.localizacao" />
        </template>
      </card-content>
    </card>

    <card titulo="Endereço">
      <card-content class="row gutters-xs">
        <template v-if="form.categoria === 'URBANO'">
          <v-input-cep :validation="validation.cep" v-model="form.cep" label="CEP" @endereco="atualizarEndereco" />
          <v-input class="col-3" type="text" label="Tipo Logradouro" v-model="form.tipoLogradouro" />
          <v-input class="col" type="text" label="Logradouro" v-model="form.logradouro" />
          <v-input class="col-2" type="text" label="Número" v-model="form.numero" />
          <div class="w-100"></div>

          <div class="col-12" v-if="!possuiListaCidadesConfigurada">
            <div class="alert alert-outline-warning alert-sm mb-2">
              <p class="mb-0">
                Necessário configurar a lista de cidades permitidas para o indicador real
              </p>
            </div>
          </div>

          <v-input class="col" type="text" label="Bairro" v-model="form.bairro" />
          <v-input class="col" label="Cidade" v-model="form.cidade" :options="options.cidades" type="v-select" :error="validation.cidade"/>
          <v-input class="col" type="select" label="Estado" v-model="form.estado" :options="options.estados" />
          <div class="w-100"></div>
          <v-input class="col" type="text" label="Complemento" v-model="form.complemento" />
        </template>

        <template v-if="form.categoria === 'RURAL'">
          <div class="w-100"></div>
          <v-input class="col-2" type="select" label="Estado" v-model="form.estado" :options="options.estados" />
          <v-input class="col-4" type="text" label="Cidade" v-model="form.cidade" />
        </template>
      </card-content>
    </card>

    <card titulo="Área">
      <card-content class="row gutters-xs">
        <template>
          <div class="w-100"></div>
          <v-input class="col" v-model="form.medidaArea" :options="options.medidas" type="select" label="Medida área" @change="updateMedidaAreaDoi" />
          <v-input class="col" label="Área total" v-model="form.areaTotalDoi" type="currency" :input-props="{precision : decimais}" />
        </template>
      </card-content>
    </card>

    <card>
      <card-content class="row gutters-xs">
        <v-input class="col-12" type="editor" label="Especificações do imóvel" v-model="form.especificacao" />
      </card-content>
    </card>


    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Cancelar</button>
      <v-button :run="save" class="btn btn-outline-primary">Salvar</v-button>
    </template>

  </modal>

</template>
<script>

import EnderecoBusiness from "@/business/EnderecoBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import IndicadorRealExternoBusiness from "@/business/indicadores/IndicadorRealExternoBusiness.js";
import ListaBusiness from "@/business/crud/ListaBusiness";
import Card from "@/components/Layout/components/Card.vue";
import Modal from "@/components/Modal";
import CardContent from "@/components/Layout/components/CardContent.vue";

export default {
  name: 'FormIndicadorRealExterno',

  components: {CardContent, Card, Modal },

  modal: {
    width: 1300
  },

  props: {
    id: String,
  },

  data() {
    return {
      titulo: 'Indicador Real Externo',
      loading: false,
      validation: {},
      form: {},
      decimais: {min: 2, max: 10},
      options: {
        tipos: [
          {id: 'MATRICULA', nome: 'Matrícula', livro: "MATRICULA", status: 'ABERTA'},
          {id: 'TRANSCRICAO', nome: 'Transcrição', livro: "TRANSCRICAO"},
          {id: 'TORRENS', nome: 'Torrens', livro: "TORRENS"},
        ],
        tiposImovel: IndicadorRealBusiness.getTiposImovel(),
        categorias: IndicadorRealBusiness.getCategorias(),
        medidas: IndicadorRealBusiness.getMedidas(),
        estados: EnderecoBusiness.getEstados(),
        serventias: [],
        cidades: [],
      }
    }
  },

  async mounted() {
    let config = this.$root.config;
    let serventia = await ListaBusiness.getById( config?.listaRegistroAnterior?.id);
    this.$set(this.options, 'serventias', (serventia || {lista: []}).lista.map(e => ({
      id: e,
      nome: e
    })));

    let indicador = {};
    if (this.id) {
      indicador = await IndicadorRealExternoBusiness.getById(this.id);
    }

    let form = {
      tipo: 'MATRICULA',
      serventia: '',
      categoria: 'URBANO',
      registro: null,
      livroNumero: '',
      livroLetra: '',
      livroFolha: '',
      ...indicador
    };

    if(indicador.estado === null || indicador.cidade === null || !this.id){
      form.estado = this.config?.estado;

      if(!this.id) {
        form.cidade = this.config?.cidade;
      }
    }

    this.$set(this, 'form', form);

    let cidades = this.config?.listaCidade?.id ? await ListaBusiness.getById(this.config?.listaCidade?.id).catch(e => ({lista: []})) : {lista: []};

    if(indicador.cidade && !cidades?.lista?.includes(indicador.cidade)){
      cidades.lista.push(indicador.cidade);
    }

    this.$set(this.options, 'cidades', (cidades || {lista: []})?.lista.map(e => ({
      id: e,
      nome: e
    })));

  },

  computed: {
    config(){
      return this.$root.config;
    },
    possuiListaCidadesConfigurada(){
      return !!this.config?.listaCidade?.id;
    },
  },

  methods: {
    close(retorno) {
      FrontBusiness.closeModal(retorno);
    },

    showError(e) {
      FrontBusiness.fullErrorHandler(this, e, '#formulario-cadastro-protocolo');
    },

    updateMedidaAreaDoi() {},

    atualizarEndereco(endereco) {
      if (endereco) {
        this.$set(this.form, 'cep', endereco.cep);
        this.$set(this.form, 'logradouro', endereco.logradouro);
        this.$set(this.form, 'bairro', endereco.bairro);
        this.$set(this.form, 'cidade', endereco.cidade);
        this.$set(this.form, 'estado', endereco.estado);
      }
    },

    async save() {
      let form = this.form;
      const validation = IndicadorRealExternoBusiness.getErrosForm(this.form) || {};
      if (Object.keys(validation).length) {
        this.$set(this, 'validation', validation);
        return;
      }

      let mensagem = await IndicadorRealExternoBusiness.verificarDuplicidade(form, form?.id).catch(this.showError);
      if (mensagem) {
        let result = await FrontBusiness.showConfirmacao(mensagem, 'Deseja continuar?', 'checkbox', 'Tenho certeza que desejo continuar.');
        if (!result?.isConfirmed) {
          return;
        }
      }

      let retorno = await IndicadorRealExternoBusiness.save(form, form?.id).catch(this.showError);
      if (retorno) {
        this.close(retorno);
      }
    },
  }
}

</script>
